import { IonButton, IonCol, IonContent, IonGrid, IonImg, IonPage, IonPopover, IonRow, IonText, IonIcon, useIonViewWillLeave } from '@ionic/react';
import { openOutline } from 'ionicons/icons';
import React, { useEffect, useRef, useState } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';
import Footer from '../../components/Footer';
import { User } from '../../models/data';
import { translation } from '../../models/translation';
import { fetchOrg } from '../../services/org_service';
import { fetchCatsIn } from '../../services/taxononmies';



interface OrgdetailProps {
    user: User | any
}

const Orgdetail: React.FC<OrgdetailProps> = ({ user }) => {

    const svgUrl = `${process.env.PUBLIC_URL}/assets/svg/`;

    const history = useHistory()

    const siteText = translation();

    const lan = siteText.lan.replace("/", "")

    const pathName = useLocation().pathname;
    //__
    const isAccountPage = () => {// revise
        if (pathName.indexOf('account') < 0) return false;
        return true
    }

    const loginFirst = () => {
        history.push({ pathname: `/${lan}/signin`, state: { destination: `/account/donate_direct_to_org_V2?id=${organization.id}` } })
    }

    const [organization, setOrganization] = useState<any>(null);
    //__
    const [organizationCategories, setOrganizationCategories] = useState<any>(null)// revise
    const { id } = useParams<{ id: string; }>();

    const popover = useRef<HTMLIonPopoverElement>(null);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const openPopover = (e: any) => {
        popover.current!.event = e;
        setPopoverOpen(true);
    };
    // fetch data
    useEffect(() => {
        let mounted = true;
        //getOrganisations().then();
        fetchOrg(id).then(
            ({ message }) => {
                if (message) {
                    setOrganization(message);
                    if (message.categories) {
                        fetchCatsIn(message.categories).then(
                            ({ message: more }) => {
                                if (more) {
                                    setOrganizationCategories(
                                        more
                                            .filter((cat: any) => cat.parent !== 0)
                                            .map((cat: any) => cat.acf[lan]).filter((name: any) => name !== "")
                                    )

                                }
                            }
                        )
                    }
                }
            }
        )
        return () => {
            mounted = false;
            setOrganization(null)
        };
    }, [id])

    useIonViewWillLeave(() => {
        setPopoverOpen(false);

    })

    const goToDonatePage = (action: any) => {
        if (action === 'direct') {
            history.push(`/${lan}/account/donate_direct_to_org_V2?id=${organization.id}`)
            return

        }
        if (action === 'credit') {
            history.push(`/${lan}/account/with_credit_to_org?id=${organization.id}`)
            return
        }
    }

    const descriptionHtml = (html: string) => {
        return { __html: html }
    }



    return (
        <IonPage className='pageContent '>
            <IonContent>
                <IonGrid className='article-body'>
                    {
                        organization &&
                        <IonRow>
                            <IonCol offsetSm='1' sizeSm='10' className='article-header' style={{backgroundColor:'white', padding:'0',borderRadius:'30px 30px 0px 0px'}}>
                                <IonRow className='sw_sp_xs organizationDetailHeader ion-margin-top'>
                                    <IonCol style={{ backgroundColor: 'white' }}  class='wrapper '>
                                        <IonImg className='' src={organization.acf[lan].logo}></IonImg>
                                        <h1 className='h2'>{organization.acf[lan].nom}</h1>
                                    </IonCol>
                                </IonRow>
                                {
                                    organization.acf.image &&
                                    <IonRow  >
                                        <IonCol style={{padding:'0'}}  className='header_273'>
                                            <IonImg   src={organization.acf.image}></IonImg>
                                        </IonCol>
                                    </IonRow>
                                }
                                <IonRow className='sw_sp_sm'>
                                    <IonCol sizeXs='12' className='ion-hide-sm-up'>
                                        {/*Dontate with credits*/}
                                        {organization.acf.external_donations &&
                                            <>
                                                {organization.acf[lan].external_donation_url && <IonButton size="small" className='sw_mb_sm' mode='ios' ><IonIcon slot='start' color='light' icon='openOutline'></IonIcon><IonText color='light'> {siteText.charityDetailPrimary} </IonText>    </IonButton>}
                                            </>}
                                        {/*donate with credit */}
                                        {!organization.acf.external_donations && <IonButton size='small' onClick={e => !user ? openPopover(e) : goToDonatePage('direct')} mode='ios' ><IonIcon slot='start' size='small' color='light' src={`${svgUrl}${'fundraise_2.svg'}`}></IonIcon><IonText color='light'>{siteText.charityDetailPrimary}</IonText></IonButton>}


                                        {/*got to website */}
                                        {organization.acf[lan].site_url && <IonButton size='small' fill='clear' href={organization.acf[lan].site_url} target='_blank' rel="noopener"><IonIcon slot='start' size='small' icon={openOutline}></IonIcon>{`${organization.acf[lan].site_url.slice(8, 28)}`}</IonButton>}
                                    </IonCol>
                                    <IonCol sizeXs="12" offsetSm="1" sizeSm='8'>

                                        <div dangerouslySetInnerHTML={descriptionHtml(organization.acf[lan].description)}></div>
                                    </IonCol>
                                    <IonCol className='ion-hide-sm-down' sizeSm='3' sizeLg='2'>
                                        {/*Dontate with credits*/}
                                        {organization.acf.external_donations &&
                                            <>
                                                {organization.acf[lan].external_donation_url && <IonButton className='sw_mb_sm' mode='ios' expand='block'><IonIcon slot='start' color='light' icon='openOutline'></IonIcon><IonText color='light'> {siteText.charityDetailPrimary} </IonText>    </IonButton>}
                                            </>}
                                        {/*donate with credit */}
                                        {!organization.acf.external_donations && <IonButton onClick={e => !user ? openPopover(e) : goToDonatePage('direct')} className='sw_mb_sm' mode='ios' expand='block'><IonIcon slot='start' size='small' color='light' src={`${svgUrl}${'fundraise_2.svg'}`}></IonIcon><IonText color='light'>{siteText.charityDetailPrimary}</IonText></IonButton>}


                                        {/*Donate through external platform */}
                                        <div className='ion-margin-bottom'>
                                            {organization.acf[lan].site_url && <IonButton fill='clear' href={organization.acf[lan].site_url} target='_blank' rel="noopener"><IonIcon slot='start' size='small' icon={openOutline}></IonIcon>{`${organization.acf[lan].site_url.slice(8, 28)}`}</IonButton>}
                                        </div>
                                    </IonCol>


                                    <IonPopover ref={popover} isOpen={popoverOpen} onDidDismiss={() => setPopoverOpen(false)}>
                                        <IonContent class="ion-padding">
                                            <p>{siteText.loginPromtMessage}</p>
                                            <IonButton onClick={loginFirst} expand='block'><IonText>{siteText.siteLoginBtnTxt}</IonText></IonButton>
                                            <IonButton routerLink={`/${lan}/signup`} style={{ textTransform: 'none' }} size='small' color="secondary" fill='clear'>{siteText.loginNoAccount}</IonButton>
                                        </IonContent>
                                    </IonPopover>
                                </IonRow>
                            </IonCol>
                        </IonRow>

                    }
                </IonGrid>
                <Footer></Footer>
            </IonContent>
        </IonPage>
    );
};

export default Orgdetail;
